<template>
  <div>
        <b-card>
      <b-row class="justify-content-end">
        <b-col md="3" class="d-flex justify-content-center">
          <b-button
            variant="primary"
            block
            :to="{
              path: '/marketing/campaign/add',
              query: { access_token: facebookToken },
            }"
          >
            Add New Campaign
          </b-button>
        </b-col>
      </b-row>
     
    <b-col cols="12" class="d-flex justify-content-end mb-2 mt-3" style="position: relative; z-index: 1;">
      <b-button variant="outline-danger"  @click="clearFilters">
        Clear Filters
      </b-button>
    </b-col>

    <b-table
    :items="filteredCampaigns"
    :fields="fields"
    striped
    responsive
    :per-page="perPage"
    :current-page="currentPage"
    :sort-by.sync="sortBy"
    :sort-desc.sync="sortDesc"
    @filtered="onFiltered"
  >

  <!-- Campaign Name Filter -->
  <template #head(name)>
    <div class="d-flex flex-column">
      <span>Campaign Name</span>
      <b-form-input v-model="filters.name" placeholder="Filter by Name" size="sm" @input="filterTable" />
    </div>
  </template>

  <!-- Budget Filter -->
  <template #head(budget)>
    <div class="d-flex flex-column">
      <span>Actual Cost</span>
      <b-form-input v-model="filters.budget" type="number" placeholder="Filter by Cost" size="sm" @input="filterTable" />
    </div>
  </template>

  <!-- Planned Budget Filter -->
  <template #head(plannedBudget)>
    <div class="d-flex flex-column">
      <span>Planned Budget</span>
      <b-form-input v-model="filters.plannedBudget" type="number" placeholder="Filter by Planned Budget" size="sm" @input="filterTable" />
    </div>
  </template>

  <!-- Status Filter -->
  <template #head(status)>
    <div class="d-flex flex-column">
      <span>Status</span>
      <b-form-select v-model="filters.status" :options="statusOptions" size="sm" @change="filterTable" />
    </div>
  </template>

 <!-- Created On Filter -->
<template #head(createdOn)>
<div class="d-flex flex-column">
<span>Created On</span>
<DatePicker 
v-model="filters.createdOn" 
range 
placeholder="Select Date Range" 
size="sm" 
class="small-datepicker"
@change="filterTable" 
:clearable="false" :input-attr="{ readonly: true }" @focus="openCalendar"
/>
</div>
</template>

<!-- Start Date Filter -->
<template #head(startDate)>
<div class="d-flex flex-column">
<span>Start Date</span>
<DatePicker 
v-model="filters.startDate" 
range 
placeholder="Select Date Range"  
size="sm" 
class="small-datepicker"
@change="filterTable" 
:clearable="false" :input-attr="{ readonly: true }" @focus="openCalendar"
/>
</div>
</template>

<!-- End Date Filter -->
<template #head(endDate)>
<div class="d-flex flex-column">
<span>End Date</span>
<DatePicker 
v-model="filters.endDate" 
range 
placeholder="Select Date Range" 
size="sm" 
class="small-datepicker"
@change="filterTable" 
:clearable="false" :input-attr="{ readonly: true }" @focus="openCalendar"
/>
</div>
</template>

      <template #cell(createdOn)="data">
        {{ formatDate(data.item.createdOn) }}
      </template>
  
      <template #cell(startDate)="data">
        {{ formatDate(data.item.startDate) }}
      </template>
      
      <template #cell(endDate)="data">
        {{ formatDate(data.item.endDate) }}
      </template>
      <template #cell(status)="data">
        {{ getStatusText(data.item.status) }}
      </template>
  
      <template #cell(avatar)="data">
        <b-avatar :src="data.value" square />
      </template>
  
      <template #cell(actions)="data">
        <b-dropdown variant="link" toggle-class="p-0" no-caret class="m-1">
          <template #button-content>
            <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle text-body" />
          </template>
          <b-dropdown-item :to="{
            name: 'marketing-campaign-view',
            params:{ id:data.item.id }
          }">
            <feather-icon icon="EyeIcon" />
            <span class="align-middle ml-1">View</span>
          </b-dropdown-item>
          <b-dropdown-item  v-if="data.item.status !== 'COMPLETED' && data.item.status !== 'CANCELLED'" :to="{
            name: 'marketing-draft-edit',
            params:{ id:data.item.id }
          }">
            <feather-icon icon="EditIcon" />
            <span class="align-middle ml-1">Edit</span>
          </b-dropdown-item>
          <b-dropdown-item @click="deleteCampaign(data.item.id)">
            <feather-icon icon="TrashIcon" />
            <span class="align-middle ml-50">Delete</span>
          </b-dropdown-item>
        </b-dropdown>
      </template>
    </b-table>
    <b-pagination v-model="currentPage" :total-rows="totalRowsAll" :per-page="perPage" align="center" size="sm" class="my-0" />
  
    </b-card>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import FaqQuestionAnswer from "./FaqQuestionAnswer.vue";
import {
  BRow,
  BCol,
  BCard,
  BFormInput,
  BCardText,
  BCardTitle,
  BMedia,
  BAvatar,
  BSpinner,
  BMediaAside,
  BMediaBody,
  BImg,
  BCardBody,
  BBadge,
  BFormGroup,
  BInputGroup,
  BInputGroupAppend,
  BPagination,
  BButton,
  BDropdown,
  BLink,
  BDropdownItem,
  BAlert,
  BCollapse,
  BFormSelect,
  BTabs,
  BTab,
  BTable,
  BFormCheckbox,
} from "bootstrap-vue";
import FeatherIcon from "@core/components/feather-icon/FeatherIcon.vue";
import PostDetails from "./PostDetails.vue";
import VFacebookLogin from "vue-facebook-login-component";
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    FaqQuestionAnswer,
    BRow,
    BCol,
    BCard,
    BFormInput,
    BCardText,
    BCardTitle,
    BMedia,
    BAvatar,
    BSpinner,
    BMediaAside,
    BMediaBody,
    BImg,
    BCardBody,
    BBadge,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BPagination,
    BButton,
    BDropdown,
    BLink,
    BDropdownItem,
    BAlert,
    BCollapse,
    FeatherIcon,
    PostDetails,
    BFormSelect,
    BTabs,
    BTab,
    BTable,
    BFormCheckbox,
    VFacebookLogin,
    DatePicker
  },
  data() {
    return {
      totalRowsAll: 0,
      filters: {
        name: "",
        budget: "",
        plannedBudget: "",
        status: null,
        createdOn: null,
        startDate: null,
        endDate: null
      },
      statusOptions: [
        { value: null, text: "All" },
        { value: "DRAFT", text: "Draft" },
        { value: "INPROGRESS", text: "In progress" },
        { value: "COMPLETED", text: "Completed" },
        { value: "CANCELLED", text: "Cancelled" }
      ],
      facebookImage:
        "https://cdn.pixabay.com/photo/2021/08/16/08/55/facebook-6549798_1280.jpg",
      facebookAppId: "",
      model: {},
      facebookToken: "",
      FB: {},
      fb: null,
      beakerToken: localStorage.getItem("accessToken"),
      scope: {},
      instagramLoggedIn: false,
      facebookLoggedIn: false,
      collapsed: false,
      accounts: [],
      instagramAccounts: [],
      media: [],
      postdetails: [],
      userId: {},
      posts: [],
      loading: false,
      content_visible: {
        facebook: this.collapsed,
        instagram: this.collapsed,
      },
      allCampaigns: [],
      totalRows: 1,
      totalRowsSchedule: 1,
      totalRowsDraft: 1,
      totalRowsCancel: 1,
      perPage: 5,
            pageOptions: [3, 5, 10],
            totalRows: 1,
            currentPage: 1,
      faqData: {
        qandA: [
          {
            question: "Schedule with Facebook",
            ans: "Answer to Question 1",
            avatar: require("../../../assets/images/socMed/Facebook_icon_2013.svg.png"),
            platform: "facebook",
            statisticsItems: [
              {
                icon: "TrendingUpIcon",
                color: "light-primary",
                title: "230k",
                subtitle: "Engagements",
                customClass: "mb-2 mb-xl-0",
              },
              {
                icon: "UserIcon",
                color: "light-info",
                title: "8.549k",
                subtitle: "Followers",
                customClass: "mb-2 mb-xl-0",
              },
            ],
          },
          {
            question: "Schedule with Instagram",
            ans: "Answer to Question 2",
            avatar: require("../../../assets/images/socMed/Instagram.svg.png"),
            platform: "instagram",
            statisticsItems: [
              {
                icon: "TrendingUpIcon",
                color: "light-primary",
                title: "230k",
                subtitle: "Engagements",
                customClass: "mb-2 mb-xl-0",
              },
              {
                icon: "UserIcon",
                color: "light-info",
                title: "8.549k",
                subtitle: "Followers",
                customClass: "mb-2 mb-xl-0",
              },
            ],
          },
          { question: "Drafts", ans: "Answer to Question 4" },
        ],
      },
      selectedSocialMedia: "facebook",
      socialMediaOptions: [
        { value: "facebook", text: "Facebook" },
        { value: "instagram", text: "Instagram" },
        { value: "linkedin", text: "LinkedIn" },
      ],
      filteredSchedule: [],
      filteredDraft: [],
      filteredCancel: [],
      sortBy: "createdOn", // Default sorting by Created On
      sortDesc: false, // Default ascending order
      fields: [
      { key: "name", label: "Campaign Name", sortable: true },
      { key: "budget", label: "Actual Cost", sortable: true },
      // { key: "plannedBudget", label: "Planned Budget", sortable: true },
      { key: "status", label: "Status", sortable: true },
      { key: "createdOn", label: "Created On", sortable: true },
      { key: "startDate", label: "Start Date", sortable: true },
      { key: "endDate", label: "End Date", sortable: true },
      { key: "actions", label: "Actions" } // Not sortable
    ],
    drafts_fields: [
      { key: "name", label: "Campaign Name", sortable: true },
      { key: "budget", label: "Actual Cost", sortable: true },
      { key: "plannedBudget", label: "Planned Budget", sortable: true },
      { key: "status", label: "Status", sortable: true },
      { key: "createdOn", label: "Created On", sortable: true },
      { key: "startDate", label: "Start Date", sortable: true },
      { key: "endDate", label: "End Date", sortable: true },
      { key: "actions", label: "Actions" } // Not sortable
    ],
      // scheduled_items: [
      //   {
      //     // eslint-disable-next-line global-require
      //     avatar: require("@/assets/images/avatars/10-small.png"),
      //     post: "Post 1 to appear here...",
      //     published_date: "Thu Apri 11, 6.00am",
      //     status: 2,
      //   },
      //   {
      //     // eslint-disable-next-line global-require
      //     avatar: require("@/assets/images/avatars/1-small.png"),
      //     post: "Post 1 to appear here...",
      //     published_date: "Thu Apri 11, 6.00am",
      //     status: 2,
      //   },
      //   {
      //     // eslint-disable-next-line global-require
      //     avatar: require("@/assets/images/avatars/9-small.png"),
      //     post: "Post 1 to appear here...",
      //     published_date: "Thu Apri 11, 6.00am",
      //     status: 2,
      //   },
      //   {
      //     // eslint-disable-next-line global-require
      //     avatar: require("@/assets/images/avatars/3-small.png"),
      //     post: "Post 1 to appear here...",
      //     published_date: "Thu Apri 11, 6.00am",
      //     status: 2,
      //   },
      // ],
      // drafts_items: [
      //   {
      //     // eslint-disable-next-line global-require
      //     avatar: require("@/assets/images/avatars/10-small.png"),
      //     post: "Post 1 to appear here...",
      //     published_date: "Thu Apri 11, 6.00am",
      //     status: 3,
      //     actions: ["edit", "delete"],
      //   },
      //   {
      //     // eslint-disable-next-line global-require
      //     avatar: require("@/assets/images/avatars/1-small.png"),
      //     post: "Post 1 to appear here...",
      //     published_date: "Thu Apri 11, 6.00am",
      //     status: 3,
      //     actions: ["edit", "delete"],
      //   },
      //   {
      //     // eslint-disable-next-line global-require
      //     avatar: require("@/assets/images/avatars/9-small.png"),
      //     post: "Post 1 to appear here...",
      //     published_date: "Thu Apri 11, 6.00am",
      //     status: 3,
      //     actions: ["edit", "delete"],
      //   },
      //   {
      //     // eslint-disable-next-line global-require
      //     avatar: require("@/assets/images/avatars/3-small.png"),
      //     post: "Post 1 to appear here...",
      //     published_date: "Thu Apri 11, 6.00am",
      //     status: 3,
      //     actions: ["edit", "delete"],
      //   },
      // ],
      status: [
        {
          1: "Published",
          2: "Scheduled",
          3: "Drafts",
        },
        {
          1: "light-success",
          2: "light-warning",
          3: "secondary",
        },
      ],
    };
  },
  methods: {
    ...mapActions("marketingModule", [
      "getAppIdAction",
      "getPostAction",
      "removePostAction", "getCampaignsListAction", "getCampaignDraftListAction", "deleteMarketingCampaignAction"
      , "updateMarketingCampaignStatusAction"
    ]),
    filterTable() {
      this.currentPage = 1; // Reset to first page when filtering
      this.totalRowsAll = this.filteredCampaigns.length;
    },
    onFiltered(filteredItems) {
    this.totalRowsAll = filteredItems.length;
    this.currentPage = 1; // Reset pagination when filtering
  },
  getStatusText(status) {
  const option = this.statusOptions.find(opt => opt.value === status);
  return option ? option.text : status;
},
    formatDate(date) {
      const options = { year: "numeric", month: "short", day: "numeric" };
      return new Date(date).toLocaleDateString("en-US", options);
    },
    openCalendar(event) {
      event.target.blur();
      event.target.click();

      document.addEventListener('click', this.closeCalendar);
    },
    closeCalendar(event) {
      const datePicker = this.$refs.datePicker.$el;
      if (!datePicker.contains(event.target)) {
        this.$refs.datePicker.hideCalendar();

        document.removeEventListener('click', this.closeCalendar);
      }
    },
    clearFilters() {
    this.filters = {
      name: "",
      budget: "",
      plannedBudget: "",
      status: null,
      createdOn: null,
      startDate: null,
      endDate: null
    };
    
    this.currentPage = 1; // Reset pagination after clearing filters
  },
    // logout() {
    //   window.location.reload();
    // },
    // handleSdkInit({ FB, scope }) {
    //   this.FB = FB;
    //   this.scope = scope;
    // },

    // onLogin(response) {
    //   this.FB.api(
    //     "/me/accounts",
    //     "GET",
    //     { fields: "name,access_token,id" },
    //     (data) => {
    //       this.facebookToken = data.data[0].access_token;
    //       this.accounts = data;
    //       localStorage.setItem("facebookToken", this.facebookToken);
    //       this.getPostAction(this.facebookToken);
    //       for (let i = 0; i < data.data.length; i++) {
    //         const accountId = data.data[i].id;
    //         this.FB.api(
    //           accountId + "?fields=connected_instagram_account",
    //           (response) => {
    //             if (
    //               response.connected_instagram_account &&
    //               response.connected_instagram_account.id
    //             ) {
    //               const instagramAccountId =
    //                 response.connected_instagram_account.id;
    //               this.instagramAccounts = instagramAccountId;
    //               this.FB.api(
    //                 instagramAccountId +
    //                   "?fields=biography,followers_count,follows_count,media_count,name,username,profile_picture_url,media",
    //                 (responseData) => {
    //                   this.media = responseData;
    //                   this.$emit("media", this.media);
    //                   // for each media item or post, get the following
    //                   for (let i = 0; i < responseData.media.data.length; i++) {
    //                     let mediaCount = responseData.media.data[i].id;
    //                     this.FB.api(
    //                       mediaCount +
    //                         "?fields=caption,like_count,media_type,media_url,timestamp,thumbnail_url,permalink,comments_count,id,ig_id,is_comment_enabled,is_shared_to_feed,media_product_type,owner,shortcode,username,comments{username,text}",
    //                       (responseMedia) => {
    //                         this.postdetails.push(responseMedia);
    //                         this.$emit("postdetails", this.postdetails);
    //                       }
    //                     );
    //                   }
    //                 }
    //               );
    //             }
    //           }
    //         );
    //       }
    //     }
    //   );

    //   this.FB.api("/me", "GET", { fields: "name" }, (data) => {
    //     this.userId = data;
    //   });
    //   // Set facebookLoggedIn to true
    //   this.$emit("facebookLoggedIn", true);
    // },
    // toggleCollapse(platform) {
    //   this.content_visible[platform] = !this.content_visible[platform];
    // },
    // handleFacebookLoggedIn(value) {
    //   this.facebookLoggedIn = value;
    // },
    // handleInstagramLoggedIn(value) {
    //   this.instagramLoggedIn = value;
    // },
    // handlePostDetails(value) {
    //   this.postdetails = value;
    // },

    // async deletePost(item) {
    //   let token = this.facebookToken;
    //   let access_token = this.beakerToken;

    //   console.log(token);
    //   axios.defaults.headers.common["Authorization"] = "Bearer " + access_token;
    //   let postId = item;

    //   this.$swal({
    //     title: "Deleting",
    //     text: "Please wait...",
    //     buttons: false,
    //     closeOnClickOutside: false,
    //     closeOnEsc: false,
    //     content: {
    //       element: "div",
    //       attributes: {
    //         className: "swal-spinner",
    //         style: "display:flex;justify-content:center;",
    //       },
    //       children: `
    //   <div className='spinner'>
    //     <div className='double-bounce1'></div>
    //     <div className='double-bounce2'></div>
    //   </div>
    // `,
    //     },
    //   });

    //   try {
    //     const response = await axios.delete(
    //       `https://graph.facebook.com/${postId}`,
    //       {
    //         params: {
    //           access_token: token,
    //         },
    //       }
    //     );

    //     this.$swal.close();
    //     this.success();
    //     this.getPostAction(this.facebookToken);
    //   } catch (error) {
    //     this.$swal.close();
    //     this.error(error.response.data);
    //   }
    // },
    success() {
      this.$swal({
        title: "Post Deleted!",
        text: "Post has been successfully deleted!",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    error(error) {
      this.$swal({
        title: "Error!",
        text: " Error deleting post!" + error,
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    // showToast() {
    //   this.$toast({
    //     component: ToastificationContent,
    //     props: {
    //       title: `Welcome ${this.name}`,
    //       icon: "BellIcon",
    //       text: "👋 You have successfully logged in!",
    //       variant: "Success",
    //     },
    //   });
    // },
    formatDate(date) {
      const options = { year: "numeric", month: "short", day: "numeric" };
      return new Date(date).toLocaleDateString("en-US", options);
    },

    async deleteCampaign(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.deleteMarketingCampaignAction(id)
            .then(() => {
              this.$swal({
                icon: "success",
                title: "Deleted!",
                text: "Campaign has been deleted",
                customClass: {
                  confirmButton: "btn btn-success",
                },
              });
             this.getCampaignsListAction().then(() => {

              this.posts = this.published_items.filter(
          (published_items) => published_items.status === "COMPLETED"
        );

          this.filteredSchedule = this.scheduled_items.filter(
            (scheduled_items) => scheduled_items.status === "SCHEDULED"
          );

          this.filteredDraft = this.drafts_items.filter(
            (drafts_items) => drafts_items.status === "DRAFT"
          );
        });
            })
            .catch((error) => {
              this.$swal({
                icon: "error",
                title: "Error!",
                text: error,
                customClass: {
                  confirmButton: "btn btn-danger",
                },
              });
            });
        } else if (result.dismiss === "cancel") {
          this.$swal({
            title: "Cancelled",
            text: "Campaign is safe :)",
            icon: "error",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
    },


    async cancelCampaign(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Cancel it!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {

          const status = "CANCELLED";
console.log("id", id);
console.log("status", status);
           this.updateMarketingCampaignStatusAction({
            id,
            status: "CANCELLED",
          })
            .then(() => {
              this.$swal({
                icon: "success",
                title: "Cancelled!",
                text: "Campaign has been Cancel",
                customClass: {
                  confirmButton: "btn btn-success",
                },
              });
             this.getCampaignsListAction().then(() => {

              this.posts = this.published_items.filter(
          (published_items) => published_items.status === "COMPLETED"
        );

          this.filteredSchedule = this.scheduled_items.filter(
            (scheduled_items) => scheduled_items.status === "SCHEDULED"
          );

          this.filteredDraft = this.drafts_items.filter(
            (drafts_items) => drafts_items.status === "DRAFT"
          );
        });
            })
            .catch((error) => {
              this.$swal({
                icon: "error",
                title: "Error!",
                text: "Failed to cancel the campaign!.",
                customClass: {
                  confirmButton: "btn btn-danger",
                },
              });
            });
        } else if (result.dismiss === "cancel") {
          this.$swal({
            title: "Cancelled",
            text: "Campaign is safe :)",
            icon: "error",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
    },
    async fetchAllCampaigns() {
    this.$swal({
      title: "Fetching Campaigns",
      text: "Please wait...",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      willOpen: () => {
        this.$swal.showLoading();
      },
    });

    try {
    await this.getCampaignsListAction();

    // ✅ Ensure allCampaigns contains unique campaigns by id
    const combinedCampaigns = [
      ...(this.published_items || []),
      ...(this.scheduled_items || []),
      ...(this.drafts_items || []),
      ...(this.cancel_items || [])
    ];

    this.allCampaigns = [...new Map(combinedCampaigns.map(item => [item.id, item])).values()];
    this.totalRowsAll = this.allCampaigns.length;

    this.$swal.close(); // Close Swal Loader
  } catch (error) {
    this.$swal.fire({
      icon: "error",
      title: "Error!",
      text: "Failed to fetch campaigns.",
      confirmButtonText: "OK",
    });
  }
  },
  },
  computed: {
    ...mapGetters("marketingModule", {
      appid: "appid",
       published_items: "campaigns",
       scheduled_items: "campaigns",
       drafts_items: "campaigns",
       cancel_items: "campaigns",
      loadingMarketing: "loading",
    }),

   // ✅ Ensure `filteredCampaigns` is unique by `id`
  filteredCampaigns() {
    if (!Array.isArray(this.allCampaigns)) return [];

    // ✅ Remove duplicates using Map() based on `id`
    const uniqueCampaigns = [...new Map(this.allCampaigns.map(item => [item.id, item])).values()];

    const filtered = uniqueCampaigns.filter((campaign) => {
      return (
        (!this.filters.name || campaign.name?.toLowerCase().includes(this.filters.name.toLowerCase())) &&
        (!this.filters.budget || campaign.budget?.toString().includes(this.filters.budget.toString())) &&
        (!this.filters.plannedBudget || campaign.plannedBudget?.toString().includes(this.filters.plannedBudget.toString())) &&
        (!this.filters.status || campaign.status === this.filters.status) &&
        (!this.filters.createdOn || (Array.isArray(this.filters.createdOn) &&
                                     new Date(campaign.createdOn) >= new Date(this.filters.createdOn[0]) &&
                                     new Date(campaign.createdOn) <= new Date(this.filters.createdOn[1]))) &&
        (!this.filters.startDate || (Array.isArray(this.filters.startDate) &&
                                     new Date(campaign.startDate) >= new Date(this.filters.startDate[0]) &&
                                     new Date(campaign.startDate) <= new Date(this.filters.startDate[1]))) &&
        (!this.filters.endDate || (Array.isArray(this.filters.endDate) &&
                                   new Date(campaign.endDate) >= new Date(this.filters.endDate[0]) &&
                                   new Date(campaign.endDate) <= new Date(this.filters.endDate[1])))
      );
    });

    this.totalRowsAll = filtered.length; // Update pagination count
    return filtered;
  }
  },
  async mounted() {
    await this.fetchAllCampaigns();   
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-faq.scss";
</style>

<style>
.dark-layout .bg-instagram {
  background-color: #8134af;
}

.btn-instagram {
  background-color: #dd2a7b;
}

.dark-layout .bg-linkedin {
  background-color: #0a66c2;
}

.btn.btn-black {
  background-color: #000000;
}

.b-avatar.avatar-description {
  width: 5rem;
  height: 5rem;
}
.small-datepicker {
  width: 120px !important;  /* Reduce width */
  font-size: 12px;  /* Adjust text size */
}
</style>